import React from 'react';
import { TbError404Off } from "react-icons/tb";
import { Link } from 'react-router-dom';

const PageNotFound = () => {
    return (<>
        <div className="pageNotFound">
            <Link to="/">
                <img src={process.env.PUBLIC_URL + '/assets/images/logo/logo_trailboss.png'} className="logoDashboard" style={{ maxWidth: '350px', width:'100%', marginBottom: '20px' }} />
            </Link>
            <div className="icon">
                <TbError404Off size={200} />
            </div>
            <div className="content">Page Not Found!
            </div>
        </div>
    </>)
};

export default PageNotFound;